import { makeSchedulesRepository } from 'shared/infra/repositories';

import { FetchCustomerScheduleHistoryUseCase } from './implementations/FetchCustomerScheduleHistoryUseCase';

let instance: FetchCustomerScheduleHistoryUseCase | null = null;

export default function makeFetchCustomerScheduleHistoryUseCase() {
  if (!instance) {
    const repository = makeSchedulesRepository();

    instance = new FetchCustomerScheduleHistoryUseCase(repository);
  }

  return instance;
}
